import type { FaireProductEntity } from "../../entity_types/product";

export const p_hysja8ga3g: FaireProductEntity = {
  token: "p_hysja8ga3g",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE LAKE BLUE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/086cd1a320a16b3ca444b498e2003ce72ee6df9b5eb5db055cc72c4354c538c9.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:08.189Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
